import { ScrollLock } from "./ScrollLock/ScrollLock.js";
import { Thumbs } from "./Thumbs/Thumbs.js";
import { Html } from "./Html/Html.js";
import { Image } from "./Image/Image.js";
import { Hash } from "./Hash/Hash.js";
import { Toolbar } from "./Toolbar/Toolbar.js";

export const Plugins = {
  ScrollLock,
  Thumbs,
  Html,
  Toolbar,
  Image,
  Hash,
};
